import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	justNow: {
		id: 'com.atlassian.migrations-platform.mpt-timeago.ui.just-now',
		defaultMessage: 'just now',
		description: 'Label for "just now" relative time',
	},
});
